export default "__VITE_ASSET__CuYpmDR6__"